import { ReactParallaxTiltProps } from "react-parallax-tilt";

export const defaultTiltProps: ReactParallaxTiltProps = {
  scale: 1.05,
  tiltMaxAngleX: 8,
  tiltMaxAngleY: 8,
  perspective: 1400,
  glareEnable: true,
  glareMaxOpacity: 0.1,
  glareColor: "#fafafa",
};
